import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NewDoc = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M19.5 2.25H4.5V20.75C4.5 21.3023 4.94772 21.75 5.5 21.75L18.5 21.75C19.0523 21.75 19.5 21.3023 19.5 20.75V2.25Z"
        fill="#664EFF"
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 1.75C3.92157 1.75 3.25 2.42157 3.25 3.25V20.75C3.25 21.5784 3.92157 22.25 4.75 22.25H19.25C20.0784 22.25 20.75 21.5784 20.75 20.75V3.25C20.75 2.42157 20.0784 1.75 19.25 1.75H4.75ZM4.25 3.25C4.25 2.97386 4.47386 2.75 4.75 2.75H19.25C19.5261 2.75 19.75 2.97386 19.75 3.25V20.75C19.75 21.0261 19.5261 21.25 19.25 21.25H4.75C4.47386 21.25 4.25 21.0261 4.25 20.75V3.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H16.5C16.7761 8 17 7.77614 17 7.5C17 7.22386 16.7761 7 16.5 7H7.5ZM7 12C7 11.7239 7.22386 11.5 7.5 11.5H16.5C16.7761 11.5 17 11.7239 17 12C17 12.2761 16.7761 12.5 16.5 12.5H7.5C7.22386 12.5 7 12.2761 7 12ZM7.5 16C7.22386 16 7 16.2239 7 16.5C7 16.7761 7.22386 17 7.5 17H12C12.2761 17 12.5 16.7761 12.5 16.5C12.5 16.2239 12.2761 16 12 16H7.5Z"
        fill={color}
      />
      <circle cx="18.75" cy="18.75" r="5.25" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.25 15.75C19.25 15.4739 19.0261 15.25 18.75 15.25C18.4739 15.25 18.25 15.4739 18.25 15.75V18.25H15.75C15.4739 18.25 15.25 18.4739 15.25 18.75C15.25 19.0261 15.4739 19.25 15.75 19.25H18.25V21.75C18.25 22.0261 18.4739 22.25 18.75 22.25C19.0261 22.25 19.25 22.0261 19.25 21.75V19.25H21.75C22.0261 19.25 22.25 19.0261 22.25 18.75C22.25 18.4739 22.0261 18.25 21.75 18.25H19.25V15.75Z"
        fill="white"
      />
    </svg>
  )
})

export default NewDoc
